import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import {Table} from 'react-bootstrap';
import moment from 'moment'
import {injectIntl} from 'react-intl';

@injectIntl @inject('growStore') @observer
export default class ToolsInfo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {growStore} = this.props;
        const {intl} = this.props;

        return (
            <div className="ToolsInfo-container">
                <Table responsive striped>
                    <thead>
                    <tr className={"bold text-center"}>
                        <td>{intl.formatMessage({id: "tool_label"})}</td>
                        <td>{intl.formatMessage({id: "average_usage_label"})}</td>
                    </tr>
                    </thead>

                    <tbody>

                    {
                        growStore.mostUsedTools.map((p, idx) => {
                            return (
                                <tr key={idx} className={'text-center'}>
                                    <td>{intl.formatMessage({id: p[0]})}</td>
                                    <td>{moment.utc(p[1] * 1000).format('HH:mm:ss')}</td>
                                </tr>)
                        })
                    }

                    </tbody>
                </Table>
            </div>
        );
    }
}